// 支付方式选择弹窗翻译

export const paymentMethod = {
    selectPaymentMethod: '選擇支付方式',
    orderSummary: '訂單摘要',
    choosePaymentMethod: '選擇您偏好的支付方式',
    creditCard: '信用卡/借記卡',
    creditCardDescription: '通過 Stripe 安全地使用您的信用卡或借記卡支付',
    paypalDescription: '使用您的 PayPal 帳戶或 PayPal 餘額支付',
    securityNote: '您的支付信息已加密並且安全',
    processing: '正在處理支付...',
    paymentFailed: '支付失敗，請重試。',
    paymentCancelled: '支付已取消。',
    invalidPaymentMethod: '選擇的支付方式無效。',
    networkError: '網絡錯誤，請檢查您的連接並重試。',
    paypalPayment: 'PayPal 支付',
    loadingPayPal: '正在載入 PayPal...',
    paypalSecurityNote: '您的支付由 PayPal 安全處理'
  };
